<div id="map" class="map-container"> </div>
<div #markerCoordinates class="markerCoordinates"></div>